/* globals window */
import getUrlParameter from '../utils';

const $ = require('jquery');

class Search {
  enableDropdownFilter() {
    $('.mammouth__search_form')
      .find('.mammouth__search_field')
      .each((i, searchField) => {
        $(searchField).focus(() => {
          $(searchField)
            .prev()
            .children()
            .next()
            .addClass('active');
        });
      });
  }

  init() {
    $('.mammouth__search_filter_container .sub-menu a').click(e => {
      e.stopPropagation();
      e.preventDefault();
      $(e.currentTarget).toggleClass('active');
    });
    $(window).click(e => {
      if (!$(e.target).hasClass('mammouth__search_field')) {
        $('.mammouth__search_filter_container .sub-menu').removeClass('active');
      }
    });
    $('.mammouth__search_filter').click(e => {
      e.stopPropagation();
      $(e.currentTarget)
        .next()
        .toggleClass('active');
    });
    $('.mammouth__search_form').submit(e => {
      e.preventDefault();
      e.stopPropagation();
      let url = '';
      const filters = $(e.currentTarget).find('.filter.active');
      const searchValue = $(e.currentTarget)
        .find('.mammouth__search_field')
        .val();
      filters.each((i, f) => {
        if (f.dataset.filter === 'author') {
          url += `&author=${searchValue}`;
        }
        if (f.dataset.filter === 'most_popular') {
          url += '&most_popular=true';
        }
      });
      if (!url.includes('author')) {
        url = `&s=${searchValue}${url}`;
      }
      window.location.href = `/?${url}`;
    });
    if (getUrlParameter('author')) {
      this.enableDropdownFilter();
      $('.mammouth__search_form')
        .find('.mammouth__search_field')
        .each((i, s) => {
          $(s).val(getUrlParameter('author'));
        });

      $('.mammouth__search_form')
        .find('.sub-menu')
        .each((i, sub) => {
          if (!$(sub).hasClass('active')) {
            $(sub).addClass('active');
          }
        });

      $('.mammouth__search_form')
        .find('.filter.author')
        .each((i, a) => {
          $(a).addClass('active');
        });
    }
    if (getUrlParameter('most_popular')) {
      this.enableDropdownFilter();
      $('.mammouth__search_form')
        .find('.sub-menu')
        .each((i, sub) => {
          if (!$(sub).hasClass('active')) {
            $(sub).addClass('active');
          }
        });
      $('.mammouth__search_form')
        .find('.filter.most_popular')
        .each((i, a) => {
          $(a).addClass('active');
        });
    }
  }
}

export default (() => new Search())();
